import React, { useEffect } from 'react';
import DragDropPhoto from '../images/DragDrop.png';
import ResizePhoto from '../images/Resize.png';
import MaxViewPhoto from '../images/MaxView.png';
import MaximizePhoto from '../images/Maximize.png';
import MinimizePhoto from '../images/Minimize.png';
import CameraSavePhoto from '../images/CameraSave.png';
import CameraIconPhoto from '../images/CameraIcon.png';
import CameraAzimuthInclinationPhoto from '../images/CameraAzimuthInclination.png';
import styled from 'styled-components';

const StyledContainer = styled.div`
width: 100%;
margin: auto;
padding: 10px 0px 10px 0px;
`;

const NavigationPage = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ fontSize: "18px" }}>
        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Navigation
        </div>
        <div style={{ margin: '10px 0px' }}>
        To zoom in and zoom out, use mouse wheel 
        </div>
        <div style={{ margin: '10px 0px' }}>
        To rotate, mouse left click and move.        
        </div>
        <div style={{ margin: '10px 0px' }}>
        Mouse double click the object, the clicked point will become the view center.        
        </div>

        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Drag and Drop
        </div>
        <div style={{ margin: '10px 0px' }}>
        Every panel can be moved by drag and drop. Click panel head and move, the following picture shows Object Info and Measurement panels are moved to the bottom of the view.
        </div>

        <StyledContainer>
            <img src={DragDropPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Resize Panel
        </div>
        <div style={{ margin: '10px 0px' }}>
        To resize panel, mouse over the panel's edge, when resize icon displayed, click and move to change panel's size.
        </div>

        <StyledContainer>
            <img src={ResizePhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Maximum and Minimum Panel
        </div>
        <div style={{ margin: '10px 0px' }}>
        To maximize the panel, click maximize icon <img src={MaximizePhoto} style={{width: '30px', height: '30px'}} alt="" /> at the top right of the panel. 
        When panel maximized, click minimize icon <img src={MinimizePhoto} style={{width: '30px', height: '30px'}} alt="" /> to minimize the panel.
        </div>

        <StyledContainer>
            <img src={MaxViewPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Save Camera
        </div>
        <div style={{ margin: '10px 0px' }}>
        To save current camera position, click icon <img src={CameraIconPhoto} style={{width: '30px', height: '30px'}} alt="" /> at the top right of the view. 
        In Save Current Camera Position dialog, enter a camera name, then click OK.
        </div>

        <StyledContainer>
            <img src={CameraSavePhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Remove Saved Camera
        </div>
        <div style={{ margin: '10px 0px' }}>
        To remove a saved camera, switch Camera panel by click Camera tab, all of the saved cameras will be listed. Click remove icon at the right end of a saved camrea. 
        To remove all saved camera, click REMOVE ALL button.
        </div>

        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Navigate to the Saved Camera
        </div>
        <div style={{ margin: '10px 0px' }}>
        In camera list, click a camera line will navigate to the saved camera position.
        </div>

        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Camera Azimuth and Inclination
        </div>
        <div style={{ margin: '10px 0px' }}>
        In the view, <img src={CameraAzimuthInclinationPhoto} style={{width: '50px', height: '30px'}} alt="" /> show the camera's azimuth and inclination.
        </div>
    </div>
  )
}

export default NavigationPage;